import { HANDLE_SCROLL, HANDLE_SIDEBAR, FETCHING_ADD_DOWNLOAD, FETCHING_EDIT_DOWNLOAD, FETCHING_REMOVE_DOWNLOAD } from "../types/main.types";

const initialState = {
	scrolled: false,
	openSidebar: false,
	isGlobalFetching: false,
	downloads: [],
	documentKey: [],
	documentName: "",
	dashboard: {
		valorization: true,
		expiration: true,
		sales: true,
		out: true,
		last: true,
	},
};

function main(state = initialState, action) {
	switch (action.type) {
		case HANDLE_SCROLL:
			return {
				...state,
				scrolled: action.payload.scrolled,
			};
		case HANDLE_SIDEBAR:
			return {
				...state,
				openSidebar: action.payload.openSidebar,
			};
		case FETCHING_ADD_DOWNLOAD:
			return {
				...state,
				downloads: state.downloads ? [...state.downloads, action.payload.file] : [action.payload.file],
			};
		case FETCHING_EDIT_DOWNLOAD:
			return {
				...state,
				downloads: action.payload.downloads,
			};
		case FETCHING_REMOVE_DOWNLOAD:
			return {
				...state,
				downloads: state.downloads.filter((download) => download.key !== action.payload.uuid),
			};
		default:
			return state;
	}
}

export default main;
